import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/theme/imgs/icon_campi.svg'
import _imports_1 from '@/theme/imgs/regole_prezzi_orari.svg'
import _imports_2 from '@/theme/imgs/calendario_prezzi_orari.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-21375ceb")

_pushScopeId("data-v-21375ceb")
const _hoisted_1 = { class: "nav-container flexbox-row justify-space-between padding-bottom-20 padding-top-20" }
const _hoisted_2 = { class: "title color-white" }
const _hoisted_3 = { class: "button-text montserrat" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "modal-text-container" }
const _hoisted_7 = { class: "color-white montserrat modal-text" }
const _hoisted_8 = { class: "color-white montserrat modal-text margin-top-40" }
const _hoisted_9 = { class: "button-row flexbox-row justify-space-between" }
_popScopeId()

import { uppercase } from "@/services/mapping.service";
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import ClubGallery from "./club-gallery/ClubGallery.vue";
import ManagersList from "@/components/managers-list/ManagersList.vue";
import { client } from "@/api/client-v2";
import { showToast } from "@/services/error-management.service";
import { useStore } from "@/store/store";


export default _defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const openedModal = ref(null);
const selectedTab = ref(0);
const userIsOwner = ref(false);
const { t, locale } = useI18n();

switch (route.query.tab) {
  case "price-rules":
    selectedTab.value = 2;
    break;
}

// CLEAR QUERY
setTimeout(() => {
  const query = Object.assign({}, route.query);
  delete query.tab;
  router.replace({ query });
}, 150);

function redirect(page: string) {
  router.push(page);
}

function closeModal() {
  openedModal.value = null;
}

function openModal(modal: string) {
  openedModal.value = modal;
}

function onChangeTab(event) {
  selectedTab.value = event;
}

function goToAddClubPage() {
  redirect("add-new-club");
}

function selectTab(event) {
  selectedTab.value = event;
}

const getOwnership = async () => {
  try {
    const response = await client.userIsClubOwner({ clubId: store.getters.getMyClub.club_id });
    userIsOwner.value = response.data.message.is_owner;
  } catch (error) {
    showToast('Si è verificato un errore');
  }
}

onMounted(() => {
  getOwnership();
});

return (_ctx: any,_cache: any) => {
  const _component_ModifyClub = _resolveComponent("ModifyClub")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ModifyPlaygrounds = _resolveComponent("ModifyPlaygrounds")!
  const _component_PricesRules = _resolveComponent("PricesRules")!
  const _component_PricesCalendar = _resolveComponent("PricesCalendar")!
  const _component_ClubSettings = _resolveComponent("ClubSettings")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_PadelButton = _resolveComponent("PadelButton")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_unref(t)('my_club')), 1),
      _createVNode("div", {
        class: "cursor-pointer color-blue flexbox-row align-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal('ADD_CLUB')))
      }, [
        _createVNode("span", _hoisted_3, _toDisplayString(_unref(uppercase)(_unref(t)('register_new_club'))), 1),
        _hoisted_4
      ])
    ]),
    _createVNode(_component_TabView, {
      class: "tab-view",
      activeIndex: selectedTab.value,
      onTabChange: _cache[2] || (_cache[2] = ($event: any) => (onChangeTab($event.index)))
    }, {
      default: _withId(() => [
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("span", {
              class: ["material-icons", { 'color-blue': selectedTab.value === 0 }]
            }, "villa", 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 0 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('my_centre'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 0)
              ? (_openBlock(), _createBlock(_component_ModifyClub, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("span", {
              class: ["material-icons", { 'color-blue': selectedTab.value === 1 }]
            }, "add_photo_alternate", 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 1 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('Gallery'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 1)
              ? (_openBlock(), _createBlock(ClubGallery, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("img", {
              src: _imports_0,
              alt: "",
              class: { 'filter-blue': selectedTab.value === 2 }
            }, null, 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 2 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('my_playgrounds'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 2)
              ? (_openBlock(), _createBlock(_component_ModifyPlaygrounds, {
                  key: 0,
                  onSelectTab: selectTab
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("img", {
              src: _imports_1,
              alt: "",
              class: { 'filter-blue': selectedTab.value === 3 }
            }, null, 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 3 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('prices_rules'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 3)
              ? (_openBlock(), _createBlock(_component_PricesRules, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("img", {
              src: _imports_2,
              alt: "",
              class: { 'filter-blue': selectedTab.value === 4 }
            }, null, 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 4 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('prices_calendar'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 4)
              ? (_openBlock(), _createBlock(_component_PricesCalendar, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _createVNode("span", {
              class: ["material-icons", { 'color-blue': selectedTab.value === 5 }]
            }, "settings", 2),
            _createVNode("span", {
              class: { 'color-blue': selectedTab.value === 5 }
            }, _toDisplayString(_unref(uppercase)(_unref(t)('settings'))), 3)
          ]),
          default: _withId(() => [
            (selectedTab.value === 5)
              ? (_openBlock(), _createBlock(_component_ClubSettings, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (userIsOwner.value)
          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
              header: _withId(() => [
                _createVNode("span", {
                  class: ["material-icons", { 'color-blue': selectedTab.value === 6 }]
                }, "groups", 2),
                _createVNode("span", {
                  class: { 'color-blue': selectedTab.value === 6 }
                }, _toDisplayString(_unref(uppercase)(_unref(t)('clubManagers'))), 3)
              ]),
              default: _withId(() => [
                (selectedTab.value === 6)
                  ? (_openBlock(), _createBlock(ManagersList, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["activeIndex"]),
    (openedModal.value === 'ADD_CLUB')
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_DumbModal, {
            title: _unref(t)('register_new_club'),
            onHide: _cache[5] || (_cache[5] = ($event: any) => (closeModal()))
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_unref(t)('add_new_club_text')), 1),
                _createVNode("div", _hoisted_8, _toDisplayString(_unref(t)('wanna_continue')), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("p", {
                  class: "color-blue button-text montserrat cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (closeModal()))
                }, _toDisplayString(_unref(uppercase)(_unref(t)('abort'))), 1),
                _createVNode(_component_PadelButton, {
                  label: _unref(uppercase)(_unref(t)('proceed')),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goToAddClubPage()))
                }, null, 8, ["label"])
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})